const TONES = {
  default: "bg-emerald-50 text-primary",
  danger: "bg-rose-50 text-rose-700",
  warning: "bg-amber-50 text-amber-700",
  info: "bg-sky-50 text-sky-700",
  neutral: "bg-slate-100 text-slate-600",
};

export function KpiCard({ label, value, icon: Icon, tone = "default", testId }) {
  return (
    <div
      data-testid={testId}
      className="bg-white rounded-2xl p-5 border border-slate-200/80 shadow-sm hover:shadow-md transition-shadow duration-200 flex items-center gap-4 h-full group"
    >
      {Icon && (
        <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 transition-transform duration-200 group-hover:scale-105 ${TONES[tone] || TONES.default}`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
      <div className="min-w-0">
        <p className="text-2xl sm:text-3xl font-bold font-display text-slate-900 tracking-tight leading-none">{value ?? "—"}</p>
        <p className="mt-1.5 text-xs font-semibold text-slate-500 uppercase tracking-wider truncate">{label}</p>
      </div>
    </div>
  );
}

export function KpiGrid({ children }) {
  return <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 w-full">{children}</div>;
}

export default KpiCard;
